import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store'; // Adjust the path if needed

// Define the initial state for the slice
export type TloadingPosition = "Table" | "Header" | ""
export type TtriggerLoadingState = "Report" | "DrillThru" | "TableSettings" | "" | "RefreshVUTable" | "DrillThruComplete" | "ExpandAllVU" | "CollapseAllVU" | "RefreshParams" | 
"RefreshParamsCancel" | "RefreshParamsFailed" | "BuildQuery"
export interface ItriggerLoadingState {
    isLoading: boolean,
    triggerKey: null | number,
    loadingPosition: TloadingPosition,
    triggerLoadingState: TtriggerLoadingState
}
interface TriggerState {
    triggerState: { [vuId: number]: ItriggerLoadingState };
}

const initialState: TriggerState = {
    triggerState: {},
};
// Create the slice
// const triggerSlice = createSlice({
//     name: 'trigger',
//     initialState,
//     reducers: {
//         // Action to update triggerKey and TriggerName together
//         setTriggerState: (
//             state,
//             action: PayloadAction<{ vuId: number, triggerKey: number | null; loadingPosition: "TableSettings" | "DrillThru" | "" | "Report", triggerLoadingState: "Table" | "Header" | "" }>
//         ) => {
//             const { vuId, triggerKey, loadingPosition, triggerLoadingState } = action.payload;
//             state.triggerState[vuId] = {
//                 triggerKey: triggerKey,
//                 loadingPosition: loadingPosition,
//                 triggerLoadingState: triggerLoadingState
//             }
//         },
//         // Action to update only triggerKey
//         setTriggerKey: (state, action: PayloadAction<{ vuId: number, triggerKeyVal: number | null }>) => {
//             // state.triggerState[vuId].triggerKey = action.payload;
//             state.triggerState[vuId].loadingPosition = triggerKeyVal
//         },
//         resetTriggerState: (state, action: PayloadAction<{ vuId: number, triggerKey: number | null; loadingPosition: "TableSettings" | "DrillThru" | "" | "Report", triggerLoadingState: "Table" | "Header" | "" }>) => {
//             // state.triggerState[vuId].triggerKey = action.payload;
//             const { vuId } = action.payload
//             state.triggerState[vuId] = (prev:ItriggerLoadingState) => {return ({ ...prev, loadingPosition: "", triggerLoadingState: "", }))
//         },

//     },
// });
const triggerSlice = createSlice({
    name: 'triggerLoadingState',
    initialState,
    reducers: {
        setTriggerState(state, action: PayloadAction<{ vuId: number, loadingPosition: TloadingPosition, triggerLoadingState: TtriggerLoadingState, triggerKey: number | null, isLoading: boolean }>) {
            const { vuId, loadingPosition, triggerLoadingState, triggerKey, isLoading } = action.payload;
            // if (!state.triggerState[vuId]) {
            //     state.triggerState[vuId] = {};
            // }
            state.triggerState[vuId] = {
                isLoading: isLoading,
                loadingPosition: loadingPosition,
                triggerLoadingState: triggerLoadingState,
                triggerKey: triggerKey
            }
        },
        setTriggerName(state, action: PayloadAction<{ vuId: number, loadingPosition: "Header" | "Table", triggerLoadingState: "Report" | "DrillThru" }>) {
            const { vuId, loadingPosition } = action.payload;
            state.triggerState[vuId] = {
                ...state.triggerState[vuId],
                loadingPosition: loadingPosition,
            }
        },
        setTriggerKey(state, action: PayloadAction<{ vuId: number, triggerKey: number | null }>) {
            const { vuId, triggerKey } = action.payload;
            state.triggerState[vuId] = {
                ...state.triggerState[vuId],
                triggerKey: triggerKey,
            }
        },
        setTriggerLoadingState(state, action: PayloadAction<{ vuId: number, triggerLoadingState: "Table" | "Header" | "" }>) {
            const { vuId, triggerLoadingState } = action.payload;
            state.triggerState[vuId] = {
                ...state.triggerState[vuId],
                loadingPosition: triggerLoadingState,
            }
        },
        setTriggerIsLoading(state, action: PayloadAction<{ vuId: number, isLoading: boolean }>) {
            const { vuId, isLoading } = action.payload;
            state.triggerState[vuId] = {
                ...state.triggerState[vuId],
                isLoading: isLoading,
            }
        },
        resetTriggerState(state, action) {
            const { vuId } = action.payload;
            if (state.triggerState[vuId]) {
                state.triggerState[vuId] = {
                    ...state.triggerState[vuId],
                    loadingPosition: '',
                    triggerLoadingState: '',
                };
            }
        },
    },
});

// Export the action and selector
export const { setTriggerKey, setTriggerName, setTriggerState, setTriggerLoadingState, setTriggerIsLoading } = triggerSlice.actions;

export const selectTriggerState = (state: RootState) => state.trigger.triggerState;

// Export the reducer to be added to the store
export default triggerSlice.reducer;